import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailmergeRowComponent } from './mailmerge-row.component';
import { MembersearchCellModule } from '../membersearch-cell/membersearch-cell.module';
import { PhoneNumberCellModule } from '../phone-number-cell/phone-number-cell.module';
import { MailmergeRegularCellModule } from '../regular-cell/regular-cell.module';
import { EventSpyModule } from '@schoolbelle/common/table';


@NgModule({
  declarations: [MailmergeRowComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MembersearchCellModule, PhoneNumberCellModule, MailmergeRegularCellModule,
    EventSpyModule,    
  ],
  exports:[MailmergeRowComponent],
})
export class MailmergeRowModule { }
